export const TOGGLE_ANNOUNCEMENTS_LOADING = 'TOGGLE_ANNOUNCEMENTS_LOADING';

export const SET_ANNOUNCEMENTS_ERROR = 'SET_ANNOUNCEMENTS_ERROR';
export const CLEAR_ANNOUNCEMENTS_ERROR = 'CLEAR_ANNOUNCEMENTS_ERROR';

export const FETCH_ANNOUNCEMENTS_REQUEST = 'FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_ANNOUNCEMENTS_FAILURE = 'FETCH_ANNOUNCEMENTS_FAILURE';
export const FETCH_ANNOUNCEMENTS_SUCCESS = 'FETCH_ANNOUNCEMENTS_SUCCESS';

export const FETCH_ANNOUNCEMENT_COMMENTS_REQUEST = 'FETCH_ANNOUNCEMENT_COMMENTS_REQUEST';
export const FETCH_ANNOUNCEMENT_COMMENTS_FAILURE = 'FETCH_ANNOUNCEMENT_COMMENTS_FAILURE';
export const FETCH_ANNOUNCEMENT_COMMENTS_SUCCESS = 'FETCH_ANNOUNCEMENT_COMMENTS_SUCCESS';

export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_FAILURE = 'ADD_COMMENT_FAILURE';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';

export const SYNC_COMMENTS_COUNT = 'SYNC_COMMENTS_COUNT';

export const ADD_ANNOUNCEMENT_REQUEST = 'ADD_ANNOUNCEMENT_REQUEST';
export const ADD_ANNOUNCEMENT_FAILURE = 'ADD_ANNOUNCEMENT_FAILURE';
export const ADD_ANNOUNCEMENT_SUCCESS = 'ADD_ANNOUNCEMENT_SUCCESS';

export const DELETE_ANNOUNCEMENT_COMMENT_REQUEST = 'DELETE_ANNOUNCEMENT_COMMENT_REQUEST';
export const DELETE_ANNOUNCEMENT_COMMENT_FAILURE = 'DELETE_ANNOUNCEMENT_COMMENT_FAILURE';
export const DELETE_ANNOUNCEMENT_COMMENT_SUCCESS = 'DELETE_ANNOUNCEMENT_COMMENT_SUCCESS';

export const DELETE_ANNOUNCEMENT_REQUEST = 'DELETE_ANNOUNCEMENT_REQUEST';
export const DELETE_ANNOUNCEMENT_FAILURE = 'DELETE_ANNOUNCEMENT_FAILURE';
export const DELETE_ANNOUNCEMENT_SUCCESS = 'DELETE_ANNOUNCEMENT_SUCCESS';

export const EDIT_ANNOUNCEMENT_REQUEST = 'EDIT_ANNOUNCEMENT_REQUEST';
export const EDIT_ANNOUNCEMENT_FAILURE = 'EDIT_ANNOUNCEMENT_FAILURE';
export const EDIT_ANNOUNCEMENT_SUCCESS = 'EDIT_ANNOUNCEMENT_SUCCESS';

export const EDIT_COMMENT_REQUEST = 'EDIT_COMMENT_REQUEST';
export const EDIT_COMMENT_FAILURE = 'EDIT_COMMENT_FAILURE';
export const EDIT_COMMENT_SUCCESS = 'EDIT_COMMENT_SUCCESS';

export const SYNC_EXISTING_ANNOUNCEMENTS_REQUEST = 'SYNC_EXISTING_ANNOUNCEMENTS_REQUEST';
export const SYNC_EXISTING_ANNOUNCEMENTS_FAILURE = 'SYNC_EXISTING_ANNOUNCEMENTS_FAILURE';
export const SYNC_EXISTING_ANNOUNCEMENTS_SUCCESS = 'SYNC_EXISTING_ANNOUNCEMENTS_SUCCESS';
